import { makeStyles } from '@material-ui/core/styles';
import Theme from '../../theme/booking-theme';

const useStyles = makeStyles({
  root: {
    maxHeight: '60px',
    position: 'fixed',
    top: '0',
    transition: 'all 0.35s',
    transform: 'translateY(-130px)',
    width: '100%',
    zIndex: '12',
    [Theme.breakpoints.down('xs')]: {
      top: '64px',
    },
    '&.open': {
      transform: 'translateY(0px)',
      [Theme.breakpoints.up('sm')]: {
        maxHeight: '60px;',
      },
      [Theme.breakpoints.down('xs')]: {
        maxHeight: '94px',
      },
    },
    '& .MuiCardContent-root:last-child': {
      paddingBottom: 0,
    },

    '& .card-content': {
      padding: 0,

      '& .notificationContainer': {
        [Theme.breakpoints.up('lg')]: {
          flexWrap: 'nowrap',
        },
      },

      '& .icon-container': {
        alignItems: 'center',

        display: 'flex',
        justifyContent: 'flex-end',

        [Theme.breakpoints.up('lg')]: {
          paddingRight: '25px',
          flexBasis: 'unset',
          flexGrow: 'unset',
          maxWidth: 'unset',
        },
        [Theme.breakpoints.up('xl')]: {
          width: '50%',
        },

        [Theme.breakpoints.down('md')]: {
          justifyContent: 'center',
          padding: 0,

          [Theme.breakpoints.only('xs')]: {
            justifyContent: 'flex-start',
            padding: '10px 16px',
          },
        },

        '&__icon': {
          display: 'none',
          fill: 'white',
          height: '22px',
          width: '24px',
        },
      },

      '& .message': {
        padding: '10px 16px',
        maxWidth: '1380px',

        [Theme.breakpoints.only('sm')]: {
          padding: '14px 16px',
        },

        [Theme.breakpoints.only('xs')]: {
          padding: '16px',
        },
        [Theme.breakpoints.up('lg')]: {
          width: '100%',
        },

        '@media (max-width: 1420px) and (min-width: 1300px)': {
          minWidth: '1208px',
        },

        '@media (min-width: 1430px)': {
          minWidth: '1280px',
        },

        '&__description': {
          ...Theme.rccl.body2,

          '&__link': {
            textDecoration: 'none',
            color: Theme.palette.blue2,
          },

          [Theme.breakpoints.down('sm')]: Theme.rccl.body3,
        },

        '&__title': {
          ...Theme.rccl.labelMediumBold,

          textTransform: 'uppercase',

          [Theme.breakpoints.down('sm')]: Theme.rccl.labelSmallBold,

          [Theme.breakpoints.only('xs')]: {
            position: 'absolute',
            top: '14px',
          },
        },
      },

      '& .button-container': {
        alignItems: 'center',
        display: 'flex',

        [Theme.breakpoints.only('xs')]: {
          position: 'absolute',
          right: 0,

          '& .MuiCardActions-root': {
            padding: '2px',

            '& g': {
              fill: 'white',
            },
          },
        },
        [Theme.breakpoints.up('lg')]: {
          paddingRight: '25px',
          flexBasis: 'unset',
          flexGrow: 'unset',
          maxWidth: 'unset',
        },
        [Theme.breakpoints.up('xl')]: {
          width: '50%',
        },
      },
    },

    [Theme.breakpoints.only('xs')]: {
      '& .card-content': {
        '& .icon-container': {
          justifyContent: 'flex-start',
        },
      },
    },
    '&.error': {
      '& .icon-container': {
        backgroundColor: Theme.palette.error.main,
      },
      '& g': {
        fill: Theme.palette.error.main,
      },
      '& h3.message__title, & h5.message__description': {
        color: Theme.palette.error.main,
      },
      '& .icon-container__icon.error': {
        display: 'block',
      },
    },
    '&.success': {
      '& .icon-container': {
        backgroundColor: Theme.successful,
      },
      '& .actions g': {
        fill: Theme.successful,
      },
      '& h3.message__title, & h5.message__description': {
        color: Theme.successful,
      },
      '& .icon-container__icon.success': {
        display: 'block',
      },
    },
  },
});

export default useStyles;
